import LessonPlayerMarkingContext, {
  LessonPlayerMarkingContextConsumer
} from '../../assessments/models/LessonPlayerMarkingContext';
import React, { useState } from 'react';

import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Unstable_Grid2';
import { WholeNumberField } from '../../shared/components/WholeNumberField';
import styles from '../styles/LessonPointsField.module.css';
import { useContext } from 'react';
import { useEffect } from 'react';
import { useLessonComponentContext } from '../models/LessonComponentContext';

interface LessonPointsFieldProps {
  points: number;
  maxPoints: number;
  onPointsChange: (points: number) => void;
}

export function LessonPointsField(props: LessonPointsFieldProps) {
  const [points, setPoints] = useState(props.points);
  const { userAnswer } = useLessonComponentContext();

  useEffect(() => {
    setPoints(props.points);
  }, [props.points]);

  const { state, assignedToMe } = useContext(LessonPlayerMarkingContext);

  function handleValueChange(value: number) {
    setPoints(value);
    props.onPointsChange(value);
  }

  function canAllocatePoints() {
    return (
      //Disable points field when unassigned and unanswered questions
      state === ApiPortfolioState.AssessmentMark && assignedToMe && !!userAnswer
    );
  }

  return (
    <LessonPlayerMarkingContextConsumer>
      {({ state }) => (
        <Grid container spacing={1} alignItems="center" justifyContent="center">
          <Grid>
            <FormLabel component="legend">Allocate points:</FormLabel>
          </Grid>
          <Grid>
            <WholeNumberField
              className={styles.numberField}
              value={points}
              max={props.maxPoints}
              disabled={!canAllocatePoints()}
              onChange={handleValueChange}
            />
          </Grid>
          <Grid>
            <FormLabel component="legend">out of {props.maxPoints}</FormLabel>
          </Grid>
        </Grid>
      )}
    </LessonPlayerMarkingContextConsumer>
  );
}
